module.exports = __webpack_public_path__ + "img/logo-dashboard-header-dark.a4949e2d.png";